// extracted by mini-css-extract-plugin
var _1 = "ItmKsQVrYoLbi_CvNdSB";
export { _1 as "mainHeadingRow" }
